import { useContext, useState } from "react"
import { Context } from "../../../../../.."
import ButtonBase from "../../../../../TeacherCabinet/components/buttons/ButtonBase"
import { updateUser } from "../../../../../../http/UserAPI"

const FillProfileForm = ({onClose}) => {
    const { user } = useContext(Context)
    const [firstName, setFirstName] = useState(user.first_name)
    const [lastName, setLastName] = useState(user.last_name)

    const chageUserData = async () => {
        try {
            await updateUser({ first_name: firstName, last_name: lastName })
            onClose()
        } catch (e) {
            console.error(e)
        }
    }
    return (
        <div className="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center">
            <div className="fixed top-0 bottom-0 left-0 right-0 bg-black/30" onClick={onClose}></div>
            <div className=" bg-white p-5 rounded-2xl relative z-2">
                <div className="cursor-pointer flex justify-end" onClick={onClose}><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 1L1 17M17 17L1 1" stroke="#595959" strokeWidth="2" strokeLinecap="round" />
                </svg></div>
                <form className="flex flex-col gap-4" >
                    <h4 className="font-semibold block px-4">Введите ваши имя и фамилию</h4>
                    <input type="text" value={firstName} placeholder="Введите имя" className="border border-solid border-lavender-30 rounded-2xl" onChange={(e) => setFirstName(e.target.value)} />

                    <input type="text" value={lastName} placeholder="Введите фамилию" className="border border-solid border-lavender-30 rounded-2xl" onChange={(e) => setLastName(e.target.value)} />
                    <ButtonBase onClick={chageUserData} type="button">Сохранить</ButtonBase>
                </form>
            </div>
        </div>
    )
}

export default FillProfileForm